import { z } from 'zod';

import { IdType, ImportType } from 'modules/domains/adminApp';

import { FormFieldKey, FormState } from './types';
import { getDefaultChangelogComment } from './utils/getDefaultChangelogComment';

export const formStateSchema = z
  .object({
    [FormFieldKey.IdType]: z.nativeEnum(IdType),
    [FormFieldKey.ImportType]: z.nativeEnum(ImportType),
    [FormFieldKey.ChangeComment]: z.string(),
  })
  .transform(
    ({ idType, importType, changeComment }): FormState => ({
      idType,
      importType,
      [FormFieldKey.ChangeComment]: changeComment?.length
        ? changeComment
        : getDefaultChangelogComment(idType, importType),
    }),
  );
